import styled from 'styled-components';

export const TilesRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin: 16px 0 24px 0;
`;

export const Tile = styled.div`
  background: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TileLabel = styled.span<{ $iconColor: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.palette.text.secondary};

  svg {
    font-size: 16px;
    color: ${({ $iconColor }) => $iconColor};
  }
`;

export const TileValue = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;
